import React, { useEffect } from 'react'

import { Container, Typography } from '@mui/material'

import './PolicyScreen.scss'

function PolicyScreen() {
  useEffect(() => {
    document.title = 'Scroll & Learn | Privacy Policy'
  }, [])

  return (
    <Container sx={{ marginTop: '24px', marginBottom: '24px' }}>
      <Typography variant="h1" fontSize="52px" lineHeight={1.25}>
        Privacy Policy
      </Typography>

      <Typography variant="subtitle1" lineHeight={2}>
        Last Updated: December 2025
      </Typography>

      <br />

      <Typography variant="body1" lineHeight={2}>
        Welcome to <strong>Scroll & Learn</strong>. Your privacy, and specifically the privacy of children, is our top priority. This Privacy Policy describes
        how we handle information in our application.
      </Typography>

      <hr />

      <Typography variant="h2" fontSize="32px" lineHeight={2.5}>
        1. Compliance with Children's Privacy Laws
      </Typography>

      <Typography variant="body1" lineHeight={2}>
        Because our app is designed for a target audience that includes children under the age of 13, we strictly adhere to the{' '}
        <strong>Children’s Online Privacy Protection Act (COPPA)</strong> and the <strong>GDPR-K</strong>. We do not knowingly collect, use, or disclose
        personal information from children under 13 years of age.
      </Typography>

      <Typography variant="h2" fontSize="32px" lineHeight={2.5}>
        2. Information Collection and Use
      </Typography>

      <Typography variant="body1" lineHeight={2}>
        We believe in data minimization. We only collect the following non-personally identifiable information:
      </Typography>

      <ul>
        <li>
          <Typography lineHeight={2}>
            <b>Game Data:</b> We store high scores, level progress, and unlocked achievements. This is typically stored locally on your device.
          </Typography>
        </li>

        <li>
          <Typography lineHeight={2}>
            <b>Technical Information:</b> We may collect basic device info (model, OS version) to help us troubleshoot bugs and ensure the app runs smoothly on
            your phone.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" fontSize="32px" lineHeight={2.5}>
        3. Third-Party Services & Advertising
      </Typography>

      <Typography variant="body1" lineHeight={2}>
        To keep our app free, we may show advertisements. To ensure a safe environment for children:
      </Typography>

      <ul>
        <li>
          <Typography lineHeight={2}>We only use Google Play Certified Ad SDKs.</Typography>
        </li>

        <li>
          <Typography lineHeight={2}>
            All advertisements are served using "Child-directed" settings, which disables interest-based tracking and remarketing.
          </Typography>
        </li>

        <li>
          <Typography lineHeight={2}>We do not share any personal data with third-party analytics or advertising providers.</Typography>
        </li>
      </ul>

      <Typography variant="h2" fontSize="32px" lineHeight={2.5}>
        4. Data Retention
      </Typography>

      <Typography variant="body1" lineHeight={2}>
        Since we do not require user accounts or collect personal names/emails, we do not maintain a database of personal user profiles. Game progress is tied
        to your specific device.
      </Typography>

      <Typography variant="h2" fontSize="32px" lineHeight={2.5}>
        5. Permissions
      </Typography>

      <Typography variant="body1" lineHeight={2}>
        Our app may request certain device permissions (such as Internet access to download new trivia questions). These permissions are used solely for the
        functionality of the app.
      </Typography>

      <Typography variant="h2" fontSize="32px" lineHeight={2.5}>
        6. Changes to This Policy
      </Typography>

      <Typography variant="body1" lineHeight={2}>
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to
        review this page periodically for any changes.
      </Typography>

      <Typography variant="h2" fontSize="32px" lineHeight={2.5}>
        7. Contact Us
      </Typography>

      <Typography variant="body1" lineHeight={2}>
        If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.
      </Typography>

      <Typography variant="body1" lineHeight={2}>
        Email: Tutuums@gmail.com
      </Typography>
    </Container>
  )
}

export default PolicyScreen
